<template>
  <div class="drawer-content flex flex-col">
    <NuxtPage />
  </div>
</template>
